export const LOGIN_USER = "LOGIN_USER";
export const LOGOUT_USER = "LOGOUT_USER";
export const LOAD_ARTICLE_COMMENTS = "LOAD_ARTICLE_COMMENTS";
export const LOAD_ARTICLE_RATINGS = "LOAD_ARTICLE_RATINGS";
export const ERROR_MESSAGE = "ERROR_MESSAGE";